export default __webpack_public_path__ + "static/media/package.fccd0a15.svg";